function themeTogglerInit() {
  let headerTheme = document.querySelector('.header__theme');
  let headerThemeToggle = document.querySelector('.header__theme-toggle');

  headerTheme.addEventListener('click', () => {
    headerThemeToggle.classList.toggle('is-active');

    if (headerTheme.getAttribute("aria-checked") === "true") {
      headerTheme.setAttribute("aria-checked", "false");
    } else {
      headerTheme.setAttribute("aria-checked", "true");
    }

    document.body.classList.toggle('dark');
  })
}

export { themeTogglerInit }